import { render, staticRenderFns } from "./Barang.vue?vue&type=template&id=8d4947ca&"
import script from "./Barang.vue?vue&type=script&lang=js&"
export * from "./Barang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports